import {FilterGroup} from './get-params';

export interface ColumnValuesPayload<TColumn extends string = string> {
  columns: TColumn[];
  filterGroups?: FilterGroup[][];
  search?: string;
  limit?: number;
  includes?: string[];
}

export interface ColumnValueOption {
  value: string | number | boolean | null;
  label?: string;
  count?: number;
  [key: string]: unknown;
}

export type ColumnValuesResult<TColumn extends string = string> = Partial<
  Record<TColumn, ColumnValueOption[]>
>;

export interface ColumnValuesResponse<TColumn extends string = string> {
  data: ColumnValuesResult<TColumn>;
}
